import styled from "styled-components";

export const WalletPubHeaderWarpper = styled.div`
  background-image: url("/image-web/home/wallet-back.svg");
  background-size: cover;
  width: 100%;
  height: 110px;
  border-radius: 8px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const WalletPubHeaderText = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

export const WalletPubHeaderUser = styled.div`
  display: flex;
  align-items: center;
  > .text {
    font-weight: 400;
    font-size: 15px;
    display: flex;
    align-items: center;
    > span {
      font-weight: 700;
    }
  }

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const WalletPubHeaderValue = styled.div`
  font-weight: 700;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const WalletPubHeaderButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const WalletPubHeaderButton = styled.div`
  flex: 1;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.1);

  color: #fff;
  text-align: right;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;
